import graphql from "babel-plugin-relay/macro";

const AllExpertCornerQuery = graphql`
query AllExpertCornerQuery{
    allExpertCorner{
        edges{
          node{
             id
	        source
	        shortDescription
	        link
	        tags
	        expertCornerImage
	        created
          }
        }
    }
}
`

export default AllExpertCornerQuery;